import { render, staticRenderFns } from "./start.vue?vue&type=template&id=9b6689d2&"
import script from "./start.vue?vue&type=script&lang=js&"
export * from "./start.vue?vue&type=script&lang=js&"
import style0 from "./start.vue?vue&type=style&index=0&id=9b6689d2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports